import { ChangeDetectionStrategy, Component, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { fadeInOut } from '../../../utils/animations';
import { ProductTourBackgroundComponent } from '../product-tour-background/product-tour-background.component';
import { ButtonComponent } from '../../button/button.component';
import { ProductTourAlign, ProductTourService, ProductTourStep } from '../../../services/product-tour.service';
import { NgStyle } from '@angular/common';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-product-tour-sprouty',
  templateUrl: './product-tour-sprouty.component.html',
  styleUrl: './product-tour-sprouty.component.scss',
  animations: [fadeInOut],
  imports: [ProductTourBackgroundComponent, ButtonComponent, TranslatePipe, NgStyle],
})
export class ProductTourSproutyComponent implements AfterViewInit, OnDestroy {
  constructor(
    public productTourService: ProductTourService,
    private languageService: LanguageService,
    private ref: ChangeDetectorRef,
  ) {}

  tooltipAlign: ProductTourAlign = {};
  caretAlign: ProductTourAlign = {};
  currentStep!: ProductTourStep | null;

  private destroyed$ = new Subject<void>();

  ngAfterViewInit(): void {
    this.productTourService.currentStep$.pipe(takeUntil(this.destroyed$)).subscribe(currentStep => {
      if (this.currentStep === null) {
        // Delay the first step to allow the sprouty icon to be displayed (needed to calculate caret position)
        setTimeout(() => {
          this.currentStep = currentStep;
          currentStep && void this.updateTooltipAndCaretPositions();
        }, 150);
      } else {
        this.currentStep = currentStep;
        currentStep && void this.updateTooltipAndCaretPositions();
      }
    });
  }

  async updateTooltipAndCaretPositions(): Promise<void> {
    let toolTipNewPosition: ProductTourAlign = {};
    if (this.currentStep!.align.top === 'auto') {
      toolTipNewPosition = {
        ...this.currentStep!.align,
        top: this.calculateTopAutoPosition(this.currentStep!) + 'px',
      };
    } else {
      toolTipNewPosition = this.currentStep!.align;
    }

    // In arabic, we need to flip the tooltip position
    if (await firstValueFrom(this.languageService.arabicMode$)) {
      this.tooltipAlign = {
        ...toolTipNewPosition,
        left: toolTipNewPosition.right,
        right: toolTipNewPosition.left,
      };
    } else {
      this.tooltipAlign = toolTipNewPosition;
    }

    const element = document.querySelector(this.currentStep!.selector) as HTMLElement;
    const boundaries = element.getBoundingClientRect();

    this.caretAlign = {
      top: this.currentStep!.align.top
        ? Number(this.currentStep!.align.top === 'auto' ? this.calculateTopAutoPosition(this.currentStep!) : parseInt(this.currentStep!.align.top)) - 15 + 'px'
        : '',
      bottom: this.currentStep!.align.bottom ? parseInt(this.currentStep!.align.bottom) - 15 + 'px' : '',
      left: boundaries.x + boundaries.width / 2 + 'px',
    };

    this.ref.detectChanges();
  }

  private calculateTopAutoPosition(currentStep: ProductTourStep): number {
    let top: number = 0;

    const element = document.querySelector(currentStep.selector);

    if (element) {
      const boundaries = element.getBoundingClientRect();

      top = boundaries.top + boundaries.height + 20;
    }

    return top;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
